import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskRequirementSelfScheduleRemoved_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskRequirementSelfScheduleRemoved_ActivityLogFragment;
}

const ActivityLogTaskRequirementSelfScheduleRemoved: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.removedSelfScheduleRequest"
    />
  );
};

ActivityLogTaskRequirementSelfScheduleRemoved.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskRequirementSelfScheduleRemoved_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskRequirementSelfScheduleRemoved;
